import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CommonFns from 'functions/common.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
//单头自定义字段
import HeadCustField from 'components/headCustField';
//单身自定义字段
import BodydCustField from 'components/bodyCustField';
import { ActionContext } from 'actions/context';
import CustFieldService from 'services/custField';
import useDetail from 'hooks/useDetail';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CompanyService from 'services/company2';
import ReceiveService from 'services/receive.ts';
import Util from 'lib/util.js';
import QtyRevise from 'components/qtyRevise.jsx';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

/**
 * 收货单详情
 *
 *
 */
function ReceiveDetail(props) {
  const Config = {
    purchase: {
      title: '收货单详情',
      apiPath: '/receiveOrder/detail',
      enumMainKey: 'B02_Ro_Status',
      receiveStatusKey: 'B02_Order_Sync_Status',
      companyNameKey: 'innerVendorName',
      statusClass: ['gray', 'green', 'gray-blue', 'blue', 'orange'], //0.已冻结 1.有效 2.草稿 3.已确认 4.已撤回
      arrEnumField: [
        {
          mainKey: 'B02_Ro_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      idField: 'roXkNo',
      custFieldBillType: 12, //自定义字段单别
      wfmCode: '1033'
    }
  };
  const { state, dispatch } = useContext(ActionContext);

  let config = Config[props.type];
  config.dispatch = dispatch;
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    handleMore,
    decimalPlace,
    detail,
    setShowLoading,
    setRedirect,
    setDetail,
    workflow,
    fieldSetting,
    self
  } = useDetail(props, config);

  const [isEdit, setIsEdit] = useState(false);
  const [isReceiving, setIsReceiving] = useState(false);
  const [isShowStore, setIsShowStore] = useState(false);
  const [canRreateIqcOrder, setCanRreateIqcOrder] = useState(false);
  const [currItem, setCurrItem] = useState({});
  const [lineList, setLineList] = useState([]);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //处理详情数据
  self.afterGetDetail = async function (data) {
    data.taxRate = data.taxRate * 100 + '%';
    // 送货时间编辑展示
    data.erpReceiveDateShow =
      formatDate(data.erpReceiveDate, 'YYYY-MM-DD') || '';
    data.lineList.forEach((item, i) => {
      Util.genExtendFields(item.poLine);
      item.priceShow = item.isContainTax === 1 ? item.taxPrice : item.price;
    });
    //获取企业参数-是否启用平台收货流程
    CompanyService.getCompanyParamsByCodes(
      [companyCode],
      [
        'Use_platform_recieve_process',
        'Use_platform_verify_process',
        'Use_recieve_order_down_erp'
      ],
      true
    ).then(res => {
      let companyParams = {};
      let companyParamsFilter = {};
      res.forEach(row => {
        companyParams[row.paramCode] =
          row.paramType === 1 ? row.paramValue : row.paramValue === '1';

        companyParamsFilter[row.paramCode] = res.filter(
          item => item.paramCode === row.paramCode
        )[0].paramFilter;
      });
      let recieveProcess = companyParams['Use_platform_recieve_process'];
      let recieveDownErp = companyParams['Use_recieve_order_down_erp'];
      let verifyProcess = companyParams['Use_platform_verify_process'];

      /*
       * 启用平台收货流程，且下传ERP是收货单，收货单可收货
       */
      setIsReceiving(recieveProcess && recieveDownErp === '1');
      setIsShowStore(
        recieveProcess &&
          companyParamsFilter['Use_platform_recieve_process'] === '1' &&
          recieveDownErp === '1' &&
          Util.isEmpty(data.lineList[0].storeCode)
      );
      /*
       * 启用平台收货流程，启用来料检验、且下传ERP是收货单，收货单可转检验/展示检验相关字段
       */
      setCanRreateIqcOrder(
        recieveProcess && verifyProcess && recieveDownErp === '1'
      );
    });

    //获取物料是否能维护计价数量的权限
    if ([2, 4].includes(data.status)) {
      checkValuationQty(data.lineList);
    }
    setDetail(data);
    setLineList(data.lineList);
  };

  function handleOrder(type) {
    switch (type) {
      case 'edit':
        setIsEdit(true);
        break;
      case 'cancel':
        setIsEdit(false);
        break;
      case 'save':
        save();
        break;
      case 'publish':
        publish(detail.roXkNo);
        break;
      case 'delete':
        deleteRo(detail.roXkNo, '/receiveOrder/delete', '确认删除收货单？');
        break;
      case 'deleteItems':
        deleteItems(currItem);
        break;
      case 'createIqcOrder':
        createIqcOrder(detail.roXkNo);
        break;
      default:
    }
  }

  //保存
  function save() {
    // if (!CustFieldService.validate(detail, [], fieldSetting, true, dispatch)) {
    //   return;
    // }

    //单头提交数据
    let headData = CustFieldService.getHeadData(
      fieldSetting,
      detail,
      self.isPurchase
    );

    let postbody = {
      companyCode: companyCode,
      roXkNo: detail.roXkNo,
      erpReceiveDate: detail.erpReceiveDate,
      ...headData,
      lineList,
      apiPath: '/receiveOrder/save'
    };
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        setIsEdit(false);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //收货单发布
  function publish(roXkNo) {
    let postbody = {
      roXkNo,
      companyCode: companyCode,
      apiPath: '/receiveOrder/convertConfirm'
    };

    ReceiveService.receiveConfirm(
      postbody,
      '您确定发布收货单吗？',
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //新建送货  您确定根据此订单新建送货通知吗？
  function delivery(poXkNo, apiPath, dialogMsg) {
    let postbody = {
      companyCode: companyCode,
      poXkNo,
      apiPath: apiPath
    };
    ReceiveService.receiveConfirm(
      postbody,
      dialogMsg,
      response => {
        let data = response;
        if (!Util.isEmpty(data)) {
          self.getDetail();
          setTimeout(() => {
            setRedirect(
              '/mp/sale/delivery/detail/' + companyCode + '/' + response.data
            );
          }, 500);
        }
      },
      dispatch
    );
  }

  //删除收货单
  function deleteRo(roXkNo, apiPath, dialogMsg) {
    let postbody = {
      companyCode: companyCode,
      roXkNo,
      apiPath: apiPath
    };
    ReceiveService.receiveConfirm(
      postbody,
      dialogMsg,
      () => {
        setTimeout(() => {
          setRedirect('/mp/purchase/receive/list');
        }, 500);
      },
      dispatch
    );
  }

  //删除单身行
  function deleteItems(item) {
    if (detail.lineList.length === 1) {
      ModalService.showError(
        '明细数据至少需保留一项，如想全部删除，请删除收货单。',
        dispatch
      );
      return;
    }

    let ok = () => {
      let postbody = {
        companyCode: companyCode,
        roXkNo: self.id,
        roLineNoList: [item.lineNo],
        apiPath: '/receiveOrder/deleteOrderLine'
      };
      setShowLoading(true);
      Http.post('/api/cloudCenter', postbody).then(response => {
        setShowLoading(false);
        if (response.success) {
          ModalService.showTip('保存成功', dispatch);
          self.getDetail();
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };
    ModalService.showConfirm('是否删除项次' + item.roLineNoShow, ok, dispatch);
  }

  //获取物料是否能维护计价数量的权限
  function checkValuationQty(data) {
    data = data || [];
    let customerCode = companyCode;
    let productCodes = data.map(item => item.productCode);
    let postbody = {
      companyCode: companyCode,
      customerCode,
      productCodes,
      apiPath: '/archives/customizeCategory/checkValuationQtyFlag'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        for (const key in response.data) {
          if (Object.prototype.hasOwnProperty.call(response.data, key)) {
            data
              .filter(item => item.productCode === key)
              .forEach(item => {
                item.isEditValuationQty =
                  response.data[key] === 1 ? true : false;
              });
          }
        }
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 新建来料检验单 sourceOrderType  1来源送货单 2来源收货单 3入库单(api传)
  function createIqcOrder(roXkNo) {
    let ok = () => {
      let postbody = {
        sourceXkNo: roXkNo,
        companyCode: companyCode,
        sourceOrderType: 2,
        apiPath: '/verify/order/create'
      };
      Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          let data = response.data;
          if (!Util.isEmpty(data)) {
            let url;
            if (data.length === 1) {
              url = '/mp/purchase/iqc/detail/' + companyCode + '/' + data[0];
            } else {
              url = '/mp/purchase/iqc/list';
            }
            setRedirect(url);
          }
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };

    ModalService.showConfirm('确认新建检验单？', ok, dispatch);
  }

  // 撤回收货单
  function recallReceive() {
    let postbody = { roXkNo: self.id, companyCode: companyCode };
    ReceiveService.recallReceiveNote(
      postbody,
      data => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  // 同步ERP
  function handleAgainSync() {
    let postbody = { roXkNo: self.id, companyCode: companyCode };
    ReceiveService.syncReceiveNote(
      postbody,
      data => {
        self.getDetail();
      },
      dispatch
    );
  }

  //日期改变
  function handleDateChange(e, name) {
    let obj = {};
    if (e.target.value) {
      obj[e.target.name] = e.target.value;
      obj[name] = e.target.valueAsNumber - 28800000;
    }
    setDetail(Object.assign({}, detail, obj));
  }

  //修改入库数量
  function handleEdit(item) {
    setCurrItem(item);
    dispatch({ type: 'showQtyRevise' });
  }

  //修改单身数据成功
  function handleModalChange(data) {
    if (data === 'success') {
      self.getDetail();
    }
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //路由跳转
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">
                    {detail.innerVendorName}({detail.innerVendorCode})
                  </div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={'u-sign ' + config.statusClass[detail.status]}
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {(detail.purchaseType !== 8 ||
                  (detail.purchaseType === 8 && detail.poSyncStatus !== 0)) && (
                  <li>
                    <span className="field-label">同步状态</span>
                    <div className="field-value">
                      <span
                        className={[
                          'u-sign' +
                            ' ' +
                            CommonFns.getStatusClass('sync', detail.syncStatus)
                        ]}
                      >
                        {detail.syncStatusName}
                      </span>
                    </div>
                  </li>
                )}
                {(detail.purchaseType !== 8 ||
                  (detail.purchaseType === 8 && detail.poSyncStatus !== 0)) && (
                  <li>
                    <span className="field-label">同步消息</span>
                    <div>{detail.syncMessage}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">收货单号</span>
                  <div className="field-value">{detail.roErpNo}</div>
                </li>
                <li>
                  <span className="field-label">送货通知单号</span>
                  <div className="field-value">{detail.dnXkNo}</div>
                </li>
                <li>
                  <span className="field-label">收货日期</span>
                  {!isEdit && (
                    <div className="field-value">
                      {formatDate(detail.erpReceiveDate)}
                    </div>
                  )}
                  {isEdit && (
                    <div className="field-value">
                      <input
                        type="date"
                        name="erpReceiveDateShow"
                        className="fieldDateClass"
                        value={detail.erpReceiveDateShow || ''}
                        onChange={e => handleDateChange(e, 'erpReceiveDate')}
                      />
                    </div>
                  )}
                </li>
                <li>
                  <span className="field-label">送货日期</span>
                  <div className="field-value">
                    {formatDate(detail.deliveryDate)}
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">采购单号</span>
                  <div className="field-value">{detail.poErpNo}</div>
                </li>
                <li>
                  <span className="field-label">交易条件</span>
                  <div className="field-value">{detail.conditionName}</div>
                </li>
                <li>
                  <span className="field-label">交易币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">采购日期</span>
                  <div className="field-value">
                    {formatDate(detail.purchaseDate)}
                  </div>
                </li>
                <li>
                  <span className="field-label">交易税别</span>
                  <div className="field-value">
                    {detail.taxName}
                    {detail.taxName && ','}
                    {detail.isContainTaxName}
                    {detail.isContainTaxName && (
                      <span>, 税率{detail.taxRate}</span>
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">付款条件</span>
                  <div className="field-value">
                    {detail.payWayCode}-{detail.payWayName}
                  </div>
                </li>
                <li>
                  <span className="field-label">单别</span>
                  <div className="field-value">
                    {detail.formTypeCode}-{detail.formTypeName}
                  </div>
                </li>
                <li className={!isShowStore ? 'hide' : ''}>
                  <span className="field-label">收货仓库</span>
                  <div className="field-value">{detail.storeName}</div>
                </li>
                <li className={!isShowStore ? 'hide' : ''}>
                  <span className="field-label">收货库位</span>
                  <div className="field-value">{detail.locationName}</div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          {/* 单头自定义 */}
          <HeadCustField
            fieldSetting={fieldSetting}
            detail={detail}
            setDetail={setDetail}
            isEdit={isEdit}
            isPurchase={self.isPurchase}
          ></HeadCustField>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>收货明细</label>
          </div>
          <div className="details-item-content">
            {!Util.isEmpty(lineList) &&
              lineList.map((item, index) => (
                <div
                  className="content-line line-list-item"
                  key={String(item.id) + index}
                >
                  <div className="line-list-item-title">
                    <span>项次 {item.roLineNoShow}</span>
                    {self.isPurchase &&
                      User.checkAuth('10030203') &&
                      [2, 4].includes(detail.status) && (
                        <div className="more">
                          {isReceiving && (
                            <i
                              className="icon-edit"
                              onClick={() => {
                                handleEdit(item);
                              }}
                            ></i>
                          )}
                          {isReceiving && (
                            <i
                              className="icon-delete"
                              onClick={() => {
                                deleteItems(item);
                              }}
                            ></i>
                          )}
                        </div>
                      )}
                  </div>

                  <ul className="field-list">
                    <li>
                      <span className="field-label">产品编码</span>
                      <div className="field-value">{item.productCode}</div>
                    </li>
                    <li>
                      <span className="field-label">产品名称</span>
                      <div className="field-value">{item.productName}</div>
                    </li>
                    <li>
                      <span className="field-label">产品规格</span>
                      <div className="field-value">{item.productScale}</div>
                    </li>
                    <li>
                      <span className="field-label">采购单号</span>
                      <div className="field-value">{item.poErpNo}</div>
                    </li>
                    <li>
                      <span className="field-label">订单项次</span>
                      <div className="field-value">{item.poLineNoShow}</div>
                    </li>
                    <li>
                      <span className="field-label">收货数量</span>
                      <div className="field-value">
                        {formatNumber(item.receiveQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">计价数量</span>
                      <div className="field-value">
                        {formatNumber(
                          item.receiveValuationQty,
                          decimalPlace.QTY
                        )}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">单价</span>
                      <div className="field-value">
                        {formatNumber(item.priceShow, decimalPlace.PRICE)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">收货单位</span>
                      <div className="field-value">{item.receiveUnitName}</div>
                    </li>
                    <li>
                      <span className="field-label">计价单位</span>
                      <div className="field-value">
                        {item.valuationUnitName}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">收货仓库</span>
                      <div className="field-value">{item.storeName}</div>
                    </li>
                    <li>
                      <span className="field-label">收货库位</span>
                      <div className="field-value">{item.locationName}</div>
                    </li>
                    <li>
                      <span className="field-label">收货批号</span>
                      <div className="field-value">{item.batchNo}</div>
                    </li>
                    <li>
                      <span className="field-label">入库数量</span>
                      <div className="field-value">
                        {formatNumber(item.storageQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    <li>
                      <span className="field-label">验退数量</span>
                      <div className="field-value">
                        {formatNumber(item.returnQty, decimalPlace.QTY)}
                      </div>
                    </li>
                    {/* <li>
                        待转出货量：
                        {formatNumber(item.srcReceiveQty, decimalPlace.QTY)}
                      </li> */}
                    <li>
                      <span className="field-label">采购单单身备注</span>
                      <div className="field-value">{item.poLineRemark}</div>
                    </li>
                    {item.poLine && item.poLine.printExtendFields !== '' && (
                      <li>
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {item.poLine.printExtendFields}
                        </div>
                      </li>
                    )}
                  </ul>
                  {/* 单身自定义字段 */}
                  <BodydCustField
                    fieldSetting={fieldSetting}
                    line={item}
                    isPurchase={self.isPurchase}
                  ></BodydCustField>
                </div>
              ))}
          </div>
        </div>
      </div>

      {self.isPurchase &&
      User.checkAuth('10030203') &&
      [2, 4].indexOf(detail.status) !== -1 ? (
        <div className="wrap m-flex-box fixed-bottom">
          {isEdit && (
            <Button
              type="default"
              onClick={() => {
                handleOrder('save');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              保存
            </Button>
          )}
          {isEdit && (
            <Button
              type="default"
              onClick={() => {
                handleOrder('cancel');
              }}
              className="m-flex-item u-btn u-btn_line"
            >
              取消
            </Button>
          )}
          {!isEdit &&
            isReceiving &&
            workflow.data?.receiveOrder_publish_1?.canEdit && (
              <Button
                type="default"
                onClick={() => {
                  handleOrder('edit');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                编辑
              </Button>
            )}
          {!isEdit && workflow.data?.receiveOrder_publish_1?.canEdit && (
            <Button
              type="default"
              onClick={() => {
                handleOrder('delete');
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              删除
            </Button>
          )}
          {!isEdit && workflow.data?.receiveOrder_publish_1?.complete && (
            <Button
              className={
                isReceiving ? 'm-flex-item u-btn u-btn_primary' : 'hide'
              }
              type="default"
              onClick={() => {
                handleOrder('publish');
              }}
            >
              发布
            </Button>
          )}
        </div>
      ) : (
        ''
      )}

      {/* 送检 */}
      <div className="wrap m-flex-box fixed-bottom">
        {self.isPurchase &&
          User.checkAuth('10080102') &&
          canRreateIqcOrder &&
          [1, 3].indexOf(detail.status) !== -1 &&
          ((detail.syncStatus === 2 && detail.sourceSystem === 1) ||
            detail.sourceSystem === 2) &&
          [0, 1].includes(detail.sendVerifyStatus) && (
            <Button
              type="default"
              onClick={() => {
                handleOrder('createIqcOrder');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              送检
            </Button>
          )}
      </div>

      <div className="wrap m-flex-box fixed-bottom">
        {/* 撤回 */}
        {self.isPurchase &&
          User.checkAuth('10030203') &&
          detail.status === 3 &&
          (detail.syncStatus === 3 || detail.purchaseType === 8) && (
            <Button
              type="default"
              onClick={() => {
                recallReceive();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              撤回
            </Button>
          )}

        {/* 同步ERP */}
        {self.isPurchase &&
          User.checkAuth('10030203') &&
          detail.purchaseType !== 8 &&
          detail.status === 3 &&
          detail.syncStatus === 3 &&
          isReceiving && (
            <Button
              type="default"
              onClick={() => {
                handleAgainSync();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              同步ERP
            </Button>
          )}
      </div>

      {/* 编辑收货数量 */}
      {self.isPurchase &&
        User.checkAuth('10030203') &&
        [2, 4].indexOf(detail.status) !== -1 &&
        isReceiving &&
        !Util.isEmpty(currItem) && (
          <QtyRevise
            type="receiveOrder"
            companyCode={companyCode}
            currItem={currItem}
            decimalPlace={decimalPlace}
            fieldSetting={fieldSetting}
            isPurchase={self.isPurchase}
            onChange={handleModalChange}
          />
        )}

      <Modal></Modal>
    </div>
  );
}

ReceiveDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveDetail);
